export const GLOBAL_VIEW_ID = '*';
